import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { map, Observable } from 'rxjs'
import { ApiResponse } from 'src/app/shared/interfaces/api-response/api-response.interface'
import { environment } from 'src/environments/environment'
import { getFilterParams } from '../../helpers/get-filters'

@Injectable({
    providedIn: 'root',
})
export class QuickbooksService {
    #httpClient = inject(HttpClient)

    authorize(): Observable<string> {
        return this.#httpClient
            .get<ApiResponse<string>>(`${environment.baseUrl}quickbooks/authorize`)
            .pipe(map((x) => x.result))
    }

    callback(code: string, state: string, realmId: number): Observable<any> {
        return this.#httpClient.post(
            `${environment.baseUrl}quickbooks/callback?code=${code}&state=${state}&realmId=${realmId}`,
            {}
        )
    }

    disconnect(): Observable<any> {
        return this.#httpClient.post(`${environment.baseUrl}quickbooks/disconnect`, {})
    }

    // setDefaultTenantId(tenantId: string): Observable<any> {
    //     return this.#httpClient.put(`${environment.baseUrl}xero/tenant/${tenantId}`, {})
    // }
}
